export default "__VITE_ASSET__DdOAyaVM__"